<fgb-page-header [pageTitle]="'account.nav.profile'" [backButtonLink]="'/'"></fgb-page-header>

<ng-container *ngIf="member$ | async as member">
  <fgb-banner [bannerTitle]="member.FirstName + ' ' + member.Surname"></fgb-banner>
</ng-container>

<fgb-account-nav></fgb-account-nav>

<div class="container d-flex flex-row">
  <div class="member-card-container d-none d-lg-block">
    <h5>{{ 'account.member.card.title' | translate }}</h5>

    <fgb-member-card></fgb-member-card>
  </div>
  <div class="details-answers-container">
    <div class="details-container">
      <h5>{{ 'account.details.title' | translate }}</h5>
      <fgb-account-details></fgb-account-details>
    </div>

    <div class="answers-container">
      <h5>{{ 'account.answer.title' | translate }}</h5>
      <fgbcl-edit-questions></fgbcl-edit-questions>
    </div>
  </div>
</div>
